import { createContext } from 'react';
import { User, UserManager } from "oidc-client";

export const SecurityContext = createContext<
  Partial<{
    user: User;
    userManager: UserManager;
    unauthenticatedElement: JSX.Element;
    unauthorizedElement: JSX.Element;
    defaultRoles: string[];
    log: (msg: any[] | string) => void;
  }>
>({});
